import accessibleNav from 'accessiblenav.js';
import { getElements } from 'js-utils/src/selector';

import init from '../../common/base/init';

init(() => {
  const items = getElements('.post-share');
  if(!items.length) return;

  items.forEach((item) => {
    accessibleNav(item, {
      selSub: 'ul',
      selItem: 'li',
      selButton: 'a',
      classItemActive: 'do-show-opts',
      classEnabled: false,
      click: true,
      mouseover: true,
      keypress: true,
      outsideClick: true,
      escPress: true,
    });
  });
});
